(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-promo-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-promo-bar')) {
    customElements.define(
      'rs-promo-bar',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.events = JSON.parse(this.querySelector('[data-rs-events]')?.textContent || '[]');
          } catch (error) {
            this.events = [];
          }
          this.tab = this.querySelector('.rs-tab');
          if (!this.tab || !this.events.length) return;

          const zone = this.dataset.timeZone || 'America/Chicago';
          const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' };
          try {
            this.format = new Intl.DateTimeFormat('en-US', { ...options, timeZone: zone });
          } catch (error) {
            this.format = new Intl.DateTimeFormat('en-US', options);
          }

          this.tick();
          this.interval = setInterval(() => this.tick(), 1000);

          /* tuck the tab behind the header once the page has been scrolled. On desktop the page scrolls inside
             .page-wrapper instead of the window, so listen to scrolling anywhere (capture) and read both. */
          let frame = 0;
          const scrolled = () => {
            const wrapper = document.querySelector('.page-wrapper');
            return Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
          };
          this.onScroll = () => {
            if (frame) return;
            frame = requestAnimationFrame(() => {
              frame = 0;
              this.toggleAttribute('data-tucked', scrolled() > 40);
            });
          };
          this.onScroll();
          document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
        }

        disconnectedCallback() {
          clearInterval(this.interval);
          document.removeEventListener('scroll', this.onScroll, { capture: true });
        }

        /* ---- calendar maths, in whole days (UTC day numbers keep it free of daylight-saving jumps) ---- */

        static day(y, m, d) {
          return Date.UTC(y, m - 1, d) / 86400000;
        }

        /* nth weekday of a month, e.g. the 2nd Sunday (0) of May */
        static nthWeekday(y, m, weekday, n) {
          const first = new Date(Date.UTC(y, m - 1, 1)).getUTCDay();
          return 1 + ((weekday - first + 7) % 7) + (n - 1) * 7;
        }

        /* Western Easter Sunday (Anonymous Gregorian algorithm) */
        static easter(y) {
          const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
          const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
          const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
          return [Math.floor((h + l - 7 * m + 114) / 31), ((h + l - 7 * m + 114) % 31) + 1];
        }

        static monthDay(text) {
          const match = /^\s*(\d{1,2})\s*[-\/]\s*(\d{1,2})\s*$/.exec(text || '');
          return match ? [Number(match[1]), Number(match[2])] : null;
        }

        static seasons = { spring: ['3-20', '6-20'], summer: ['6-21', '9-22'], fall: ['9-23', '12-20'], winter: ['12-21', '3-19'] };

        /* The first and last day of an event whose last day falls in year y */
        static window(event, y) {
          const C = this;
          const lead = Math.max(0, Number(event.lead) || 0);
          const single = (m, d) => {
            const end = C.day(y, m, d);
            return { start: end - lead, end };
          };
          const range = (from, to) => {
            if (!from || !to) return null;
            const end = C.day(y, to[0], to[1]);
            let start = C.day(y, from[0], from[1]);
            if (start > end) start = C.day(y - 1, from[0], from[1]);
            return { start, end };
          };
          const thanksgiving = () => C.nthWeekday(y, 11, 4, 4);

          switch (event.event) {
            case 'new_year': return single(1, 1);
            case 'valentines': return single(2, 14);
            case 'st_patricks': return single(3, 17);
            case 'easter': return single(...C.easter(y));
            case 'mothers_day': return single(5, C.nthWeekday(y, 5, 0, 2));
            case 'fathers_day': return single(6, C.nthWeekday(y, 6, 0, 3));
            case 'july_4': return single(7, 4);
            case 'halloween': return single(10, 31);
            case 'thanksgiving': return single(11, thanksgiving());
            case 'bfcm': {
              /* Black Friday through Cyber Monday */
              const friday = C.day(y, 11, thanksgiving()) + 1;
              return { start: friday - lead, end: friday + 3 };
            }
            case 'christmas': return single(12, 25);
            case 'spring':
            case 'summer':
            case 'fall':
            case 'winter': {
              const [from, to] = C.seasons[event.event];
              return range(C.monthDay(from), C.monthDay(to));
            }
            case 'custom': return range(C.monthDay(event.start), C.monthDay(event.end));
            default: return null;
          }
        }

        /* Holidays win (in block order); a season only shows when no holiday is running */
        current(today, year) {
          const C = this.constructor;
          const isSeason = (event) => event.event in C.seasons;
          for (const pass of [false, true]) {
            for (const event of this.events) {
              if (isSeason(event) !== pass) continue;
              for (const y of [year, year + 1]) {
                const w = C.window(event, y);
                if (w && w.start <= today && today <= w.end) return { event, end: w.end };
              }
            }
          }
          return null;
        }

        tick() {
          const C = this.constructor;
          const now = Object.fromEntries(this.format.formatToParts(new Date()).map((p) => [p.type, p.value]));
          const year = Number(now.year);
          const today = C.day(year, Number(now.month), Number(now.day));
          const found = this.current(today, year);

          if (!found) {
            this.tab.hidden = true;
            return;
          }

          const { event, end } = found;
          if (this.shown !== event) {
            this.shown = event;
            this.tab.querySelector('.rs-tab__icon').textContent = event.icon || '';
            this.tab.querySelector('.rs-tab__label').textContent = event.label || '';
            this.tab.querySelector('.rs-tab__text').textContent = event.title || '';
            if (event.link) this.tab.setAttribute('href', event.link);
            else this.tab.removeAttribute('href');
            this.tab.hidden = false;
            this.dataset.theme = event.event;

            /* share today's sale with the rest of the page (e.g. the seasonal line in the marquee, blocks/rs-season-text) */
            window.rsCurrentSale = { event: event.event, title: event.title, icon: event.icon, label: event.label, link: event.link, end };
            document.dispatchEvent(new CustomEvent('rs:sale', { detail: window.rsCurrentSale }));
          }

          const timer = this.tab.querySelector('.rs-tab__timer');
          if (!timer) return;
          const pad = (n) => String(n).padStart(2, '0');
          const intoDay = Number(now.hour) * 3600 + Number(now.minute) * 60 + Number(now.second);
          let left = (end - today) * 86400 + (86400 - intoDay);
          const d = Math.floor(left / 86400);
          left %= 86400;
          const clock = `${pad(Math.floor(left / 3600))}:${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
          timer.textContent = d > 0 ? `${d}d ${clock}` : clock;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-season-ribbon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-season-ribbon')) {
    customElements.define(
      'rs-season-ribbon',
      class extends HTMLElement {
        /* falling (1) or rising (-1) particles for each theme; the characters come from the markup */
        static particles = {
          halloween: { chars: ['✦', '·'], dir: 1 },
          christmas: { chars: ['❄', '❅', '·'], dir: 1 },
          thanksgiving: { chars: ['🍂', '🍁'], dir: 1 },
          fall: { chars: ['🍂', '🍁'], dir: 1 },
          winter: { chars: ['❄', '❅'], dir: 1 },
          new_year: { chars: ['✨', '✦', '🎉'], dir: -1 },
          july_4: { chars: ['✦', '⭐', '✨'], dir: -1 },
          bfcm: { chars: ['🛍️', '✦'], dir: -1 },
          valentines: { chars: ['❤', '♥', '💕'], dir: -1 },
          st_patricks: { chars: ['☘️', '🍀'], dir: 1 },
          easter: { chars: ['🌸', '🥚', '✿'], dir: 1 },
          mothers_day: { chars: ['🌸', '🌷', '♥'], dir: -1 },
          fathers_day: { chars: ['✦', '★'], dir: -1 },
          spring: { chars: ['🌸', '✿'], dir: 1 },
          summer: { chars: ['☀', '✦'], dir: -1 },
          default: { chars: ['✦'], dir: -1 },
        };

        connectedCallback() {
          this.particlesEl = this.querySelector('.rb__particles');
          this.onSale = () => this.apply(window.rsCurrentSale);
          document.addEventListener('rs:sale', this.onSale);
          this.addEventListener('click', this.onClick);
          this.apply(window.rsCurrentSale);
        }

        disconnectedCallback() {
          document.removeEventListener('rs:sale', this.onSale);
          this.removeEventListener('click', this.onClick);
        }

        apply(sale) {
          const theme = sale?.event && this.constructor.particles[sale.event] ? sale.event : 'default';
          if (this.dataset.theme === theme && this.particlesEl.childElementCount) return;
          this.dataset.theme = theme;
          this.fill(theme);
        }

        fill(theme) {
          const { chars, dir } = this.constructor.particles[theme];
          this.particlesEl.replaceChildren();
          for (let i = 0; i < 14; i++) {
            const p = document.createElement('i');
            p.textContent = chars[i % chars.length];
            p.style.left = `${(i * 7.3 + (i % 3) * 2.1) % 100}%`;
            p.style.setProperty('--d', `${6 + (i % 5) * 1.3}s`);
            p.style.setProperty('--delay', `${-(i * 0.9)}s`);
            p.style.setProperty('--s', `${0.7 + (i % 4) * 0.15}`);
            p.style.setProperty('--dir', dir);
            this.particlesEl.append(p);
          }
        }

        onClick = async (event) => {
          const button = event.target.closest?.('.rb__code');
          if (!button) return;
          const note = this.querySelector('.rb__copied');
          try {
            await navigator.clipboard.writeText(button.dataset.code);
            if (note) note.textContent = `Copied ${button.dataset.code}`;
          } catch (error) {
            if (note) note.textContent = `Code: ${button.dataset.code}`;
          }
          this.toggleAttribute('data-copied', true);
          clearTimeout(this.copiedTimer);
          this.copiedTimer = setTimeout(() => this.removeAttribute('data-copied'), 1800);
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
